import React from 'react';
import { Box, Card, CardContent, Divider, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import Helper from '../../utility/helper';

const useStyles = makeStyles(() => ({
    cardContent: {
        padding: 0,
        '&:last-child': {
            paddingBottom: 0,
        },
    },
}));

const SatNightTransportAccordianCard = (props) =>
{
    const classess = useStyles();
    const { classes, item } = props;
    const TransportationInfo = item.actualData;

    return (
        <>
            <Divider sx={{ mb: 1 }} />
            <Card sx={{ boxShadow: 'none' }}>
                <CardContent className={classess.cardContent}>
                    <Box className={classes.rowContent}>
                    <Box
                            sx={{
                                width: '180px',
                                flexBasis: '180px',
                                flexGrow: 1,
                            }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Do you need Transportation?
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}>
                                    <span>
                                        {TransportationInfo.useTransport === 1 ? 'Yes' : 'No'}
                                    </span>
                                </Typography>
                            </Box>
                        </Box>
                        <Box
                            sx={{
                                width: '180px',
                                flexBasis: '180px',
                                flexGrow: 1,
                            }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Total Passengers
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}>
                                    <span>
                                        {TransportationInfo.totalPassengers}
                                    </span>
                                </Typography>
                            </Box>
                        </Box>
                        <Box
                            sx={{
                                width: '180px',
                                flexBasis: '180px',
                                flexGrow: 1,
                            }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Pickup Date&Time
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}>
                                    <span>
                                        {Helper.FormatDateTime(
                                            TransportationInfo.pickupDate
                                        )}
                                    </span>
                                </Typography>
                            </Box>
                        </Box>
                        <Box
                            sx={{
                                width: '180px',
                                flexBasis: '180px',
                                flexGrow: 1,
                            }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Pick-up Location
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}
                                    style={{ wordWrap: 'break-word' }}>
                                    <span>
                                        {TransportationInfo.pickupAddress}
                                    </span>
                                </Typography>
                            </Box>
                        </Box>
                        <Box
                            sx={{
                                width: '180px',
                                flexBasis: '180px',
                                flexGrow: 1,
                            }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Drop-Off Location
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}
                                    style={{ wordWrap: 'break-word' }}>
                                    <span>
                                        {TransportationInfo.dropOffAddress}
                                    </span>
                                </Typography>
                            </Box>
                        </Box>
                        <Box
                            sx={{
                                width: '180px',
                                flexBasis: '180px',
                                flexGrow: 1,
                            }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Primary Contact Name
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}
                                    style={{ wordWrap: 'break-word' }}>
                                    <span>
                                        {TransportationInfo.priContactName}
                                    </span>
                                </Typography>
                            </Box>
                        </Box>
                       
                    </Box>
                    <Box className={classes.rowContent} sx={{ mt: 1 }}>
                    <Box
                            sx={{
                                width: '180px',
                                flexBasis: '180px',
                                flexGrow: 1,
                            }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Primary Contact Email
                                </Typography>
                                <Typography
                                    variant="h4"
                                    // flexGrow={1}
                                    fontSize={14}
                                    fontWeight={400}
                                    style={{ wordWrap: 'break-word' }}>
                                    <span>
                                        {TransportationInfo.priContactEmail}
                                    </span>
                                </Typography>
                            </Box>
                        </Box>
                        <Box
                            sx={{
                                width: '180px',
                                flexBasis: '180px',
                                flexGrow: 1,
                            }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Primary Contact No.
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}>
                                    <span>
                                        {TransportationInfo.priContactNo}
                                    </span>
                                </Typography>
                            </Box>
                        </Box>
                        <Box
                            sx={{
                                width: '180px',
                                flexBasis: '180px',
                                flexGrow: 1,
                            }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Backup Contact Name
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}
                                    style={{ wordWrap: 'break-word' }}>
                                    <span>
                                        {TransportationInfo.backupContactName}
                                    </span>
                                </Typography>
                            </Box>
                        </Box>
                        <Box
                            sx={{
                                width: '180px',
                                flexBasis: '180px',
                                flexGrow: 1,
                            }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Backup Contact Email
                                </Typography>
                                <Typography
                                    variant="h4"
                                    // flexGrow={1}
                                    fontSize={14}
                                    fontWeight={400}
                                    style={{ wordWrap: 'break-word' }}>
                                    <span>
                                        {TransportationInfo.backupContactEmail}
                                    </span>
                                </Typography>
                            </Box>
                        </Box>
                        <Box
                            sx={{
                                width: '180px',
                                flexBasis: '180px',
                                flexGrow: 1,
                            }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Backup Contact No.
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}>
                                    <span>
                                        {TransportationInfo.backupContactNo}
                                    </span>
                                </Typography>
                            </Box>
                        </Box>
                        <Box
                            sx={{
                                width: '180px',
                                flexBasis: '180px',
                                flexGrow: 1,
                            }}>
                            &nbsp;
                        </Box>
                    </Box>
                    {[1, 2, 3, 4, 5].map((item) =>
                    {
                        return (
                            <Box
                                key={`InfoSpa_${item}`}
                                sx={{
                                    width: '180px',
                                    flexBasis: '180px',
                                    flexGrow: 1,
                                    mb: 1,
                                }}></Box>
                        );
                    })}
                </CardContent>
            </Card>
        </>
    );
};

export default SatNightTransportAccordianCard;
